/**
 * LinkType describes the specific UX control type which completed the product
 * shopping funnel. This is an enumeration of values for linkType prop,
 * corresponding to LinkType values for `BetaProductShoppingFinishEvent`.
 *
 * @enum {string} LinkType
 * @see https://github.com/NerdWallet/schemas/blob/master/protobuf/src/event/BetaProductShoppingFinish.proto#L43
 */
export default {
  applyNowButton: 'APPLY_NOW_BUTTON',
  institutionImage: 'INSTITUTION_IMAGE',
  offerName: 'OFFER_NAME',
  productImage: 'PRODUCT_IMAGE',
  productName: 'PRODUCT_NAME',
  applyLink: 'APPLY_LINK',
  ratesAndFeesText: 'rates_and_fees_text'
};